// models
import type { ReqSystemList } from '../models/system.model';

/**
 * System 관련 Query Keys
 *
 * @description
 * 시스템 설정 관련 query-key들을 관리합니다.
 */
export const systemKeys = {
  SYSTEM_ALL: ['system'],
  GET_SYSTEM_LIST: (params: ReqSystemList) => ['system', JSON.stringify(params)],
  GET_PUBLIC_SYSTEM_LIST: (params: ReqSystemList) => ['system', JSON.stringify(params)],
  GET_SYSTEM_LIST_BY_RANGE: (params: { clsCdStart?: number; clsCdLast?: number }) =>
    ['system', JSON.stringify(params)] as const
};
